import React, { useState } from 'react';
import './AppointmentSearch.css';

/** ===== CONFIG ===== */
const GAS_ENDPOINT = "https://script.google.com/macros/s/AKfycby5U9vpyYudtx4xt_XPmpScb4sfPnhBCTKp2LHTLypdDwAF3YH_uOCBnRw0vf6gl1wb/exec";
const SHARED_SECRET = "change-me-strong-secret"; // "" if disabled on backend

const AppointmentSearch = () => {
  const [searchPhone, setSearchPhone] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSearchAppointments = async () => {
    const cleanPhone = searchPhone.replace(/\D/g, ''); // Remove non-digits
    
    if (!cleanPhone.trim()) {
      alert('אנא הכנס מספר טלפון');
      return;
    }

    setIsSearching(true);
    setErrorMsg('');
    setSearchResults(null);

    try {
      const url = new URL(GAS_ENDPOINT);
      url.searchParams.set('action', 'appointments');
      url.searchParams.set('phone', cleanPhone);
      if (SHARED_SECRET) url.searchParams.set('secret', SHARED_SECRET);

      const response = await fetch(url.toString());
      const data = await response.json();
      
      if (!data || !Array.isArray(data)) {
        throw new Error('Invalid response format');
      }
      
      setSearchResults(data);
      
      if (data.length === 0) {
        setErrorMsg('לא נמצאו שיעורים עבור מספר זה');
      }
    } catch (error) {
      console.error('Error searching appointments:', error);
      setErrorMsg('שגיאה בחיפוש השיעורים. נסה שוב.');
      setSearchResults(null);
    } finally {
      setIsSearching(false);
    }
  };

  return (
    <section id="appointment-search" className="section appointment-search-section">
      <div className="container">
        <h2 className="section-title">חיפוש השיעורים שלי</h2>
        
        <div className="search-container">
          <p className="search-description">
            הכנס מספר טלפון כדי לראות את השיעורים שקבעת
          </p>
          
          <div className="search-input-group">
            <input
              type="tel"
              placeholder="0501234567"
              value={searchPhone}
              onChange={(e) => setSearchPhone(e.target.value)}
              className="search-input"
              onKeyPress={(e) => e.key === 'Enter' && handleSearchAppointments()}
            />
            <button 
              className="search-btn"
              onClick={handleSearchAppointments}
              disabled={isSearching}
            >
              {isSearching ? 'מחפש...' : 'חפש'}
            </button>
          </div>

          {errorMsg && !isSearching && (
            <div className="error-message">
              <p>{errorMsg}</p>
            </div>
          )}

          {searchResults && searchResults.length > 0 && (
            <div className="search-results">
              <div className="results-list">
                <h3>השיעורים שלך ({searchResults.length}):</h3>
                {searchResults.map((appointment, index) => (
                  <div key={index} className="appointment-card">
                    <div className="appointment-date">
                      <span className="label">📅 תאריך:</span>
                      <span className="value">{appointment.date}</span>
                    </div>
                    <div className="appointment-time">
                      <span className="label">🕒 שעה:</span>
                      <span className="value">{appointment.time}</span>
                    </div>
                    <div className="appointment-type">
                      <span className="label">🚗 סוג שיעור:</span>
                      <span className="value">{appointment.type}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AppointmentSearch;
